import React from 'react';
import cl from './Footer.module.css';
import { NavLink } from 'react-router-dom';

const Footer = (props) => {
  return (
    <footer className={cl.app_footer}>
      <div className={cl.app_footer_main}>
        <div className={cl.app_footer_logolinks}>
          <div className={cl.middle_line_logo}>
            <h1>{props.shopName}</h1>
          </div>
          <h1>Pagine</h1>
          <NavLink className={cl.footer_link} to="">
          Casa
          </NavLink>
          <NavLink className={cl.footer_link} to="/about">
          Chi siamo
          </NavLink>
          {/* <NavLink className = { cl.footer_link } to='/news'>News</NavLink> */}
          <NavLink className={cl.footer_link} to="/products">
          Prodotti
          </NavLink>
          <NavLink className={cl.footer_link} to="/contacts">
          Contatti
          </NavLink>
        </div>
        <div className={cl.app_footer_links}>
          <h1>Riferimenti</h1>
          <NavLink className={cl.footer_link} to="/policy">
          Politica sulla riservatezza
          </NavLink>
          <NavLink className={cl.footer_link} to="/terms">
          Termini di servizio
          </NavLink>
          <NavLink className={cl.footer_link} to="/refund-policy">
          Politica di rimborso
          </NavLink>
          <NavLink className={cl.footer_link} to="/shipping-policy">
          Politica di spedizione
          </NavLink>
          <NavLink className={cl.footer_link} to="/cookies-policy ">
          Politica sui cookie
          </NavLink>
        </div>
        <div className={cl.app_footer_info}>
          <h2>ACCETTIAMO</h2>
          <img
            src="https://cdn.icon-icons.com/icons2/1186/PNG/512/1490135017-visa_82256.png"
            alt="Visa"
          />
          <img
            src="https://www.iconarchive.com/download/i76278/designbolts/credit-card-payment/Master-Card.ico"
            alt="Master Card"
          />
        </div>
        <div className={cl.app_footer_info}>
          <h2>VOGLIAMO SENTIRE LA TUA VOCE</h2>
          <p>
          La nostra azienda è stata fondata nel 2012 con solo 3 dipendenti. Sopra il
             anni Perfectturn conta più di 500.000 clienti soddisfatti. Suo
             È importante continuare a fornire prodotti straordinari al meglio
             clienti, ognuno dei quali include il servizio clienti via telefono, SMS
             ed e-mail. Non vediamo l'ora di crescere con te!
          </p>
        </div>
      </div>
      <div className={cl.app_footer_bottom_line}>
        <p>Diritto d'autore 2023 {props.shopName}</p>
      </div>
    </footer>
  );
};

export default Footer;
